<div class="container-fluid">

  <h4 class="mb-4">კომენტარები</h4>

  <table class="table table-bordered table-hover">

    <thead>
      <tr>
        <th>ID</th>
        <th>სახელი</th>
        <th>Email</th>
        <th>კომენტარი</th>
        <th>თარიღი</th>
        <th width="220">ქმედება</th>
      </tr>
    </thead>

    <tbody>

      <tr *ngFor="let c of comments">

        <td>{{c.id}}</td>

        <td>
          {{c.name}} {{c.surname}}
        </td>

        <td>{{c.email}}</td>

        <td style="max-width:300px">
          {{c.comment}}
        </td>

        

        <td>{{c.created_at | date:'dd.MM.yyyy HH:mm'}}</td>

        <td>

          

          <button
            class="btn border"
            (click)="delete(c.id)">
            <i class="fi fi-rr-trash text-danger"></i>
          </button>

        </td>

      </tr>

    </tbody>

  </table>

</div>